import { render, staticRenderFns } from "./designSprint.vue?vue&type=template&id=177d1800&scoped=true&"
import script from "./designSprint.vue?vue&type=script&lang=js&"
export * from "./designSprint.vue?vue&type=script&lang=js&"
import style0 from "./designSprint.vue?vue&type=style&index=0&id=177d1800&scoped=true&lang=css&"
import style1 from "./designSprint.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177d1800",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('177d1800')) {
      api.createRecord('177d1800', component.options)
    } else {
      api.reload('177d1800', component.options)
    }
    module.hot.accept("./designSprint.vue?vue&type=template&id=177d1800&scoped=true&", function () {
      api.rerender('177d1800', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/prekickoff/designSprint/designSprint.vue"
export default component.exports